import PropTypes from 'prop-types';
import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconArrowSmall = ({ color, size = 14 }) => {
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  return (
    <SVG width={size} height={(10 / 14) * size} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.01117 5.03259L11.6778 5.00292" stroke={colorCode} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.73352 1.01099L12.7446 4.99984L8.75578 9.01096"
        stroke={colorCode}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};
IconArrowSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
export { IconArrowSmall as default, IconArrowSmall };
